var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import TubeMaterialSelection from "../../components/articleattributes/tubematerialselection.vue";
import TubeProfileSelection from "../../components/articleattributes/tubeprofileselection.vue";
import TubeSpecificationSelection from "../../components/articleattributes/tubespecificationselection.vue";
import { isString, } from "../utilities/wsi4_typeguards";
let TubeElement = class TubeElement extends Vue {
    constructor() {
        super(...arguments);
        this.tubeProfileId = "";
        this.tubeMaterialId = "";
        this.tubeSpecificationId = "";
    }
    tubeIdChanged() { return this.tubeId; }
    initialize() {
        if (this.tubeId === this.value) {
            return;
        }
        const t = this.shopConfig.tubes.find(t => t.identifier === this.value);
        if (t === undefined) {
            this.tubeSpecificationId = "";
            this.tubeMaterialId = "";
            this.tubeProfileId = "";
            return;
        }
        this.tubeProfileId = t.tubeProfileId;
        this.tubeMaterialId = t.tubeMaterialId;
        this.tubeSpecificationId = t.tubeSpecificationId;
    }
    setTubeProfileId(t) {
        if (!isString(t)) {
            throw Error("Wrong type.");
        }
        this.tubeProfileId = t;
    }
    setTubeMaterialId(t) {
        if (!isString(t)) {
            throw Error("Wrong type.");
        }
        this.tubeMaterialId = t;
    }
    setTubeSpecificationId(t) {
        if (!isString(t)) {
            throw Error("Wrong type.");
        }
        this.tubeSpecificationId = t;
    }
    get elementKey() { return "tubeCuttingData"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get tubes() {
        return this.shopConfig.tubes.map(tube => ({
            tubeProfileId: tube.tubeProfileId,
            tubeMaterialId: tube.tubeMaterialId,
            tubeSpecificationId: tube.tubeSpecificationId,
        }));
    }
    get tubeProfiles() {
        return this.tubes.map(t => t.tubeProfileId);
    }
    get materials() {
        return this.tubes.filter(t => t.tubeProfileId === this.tubeProfileId)
            .map(t => t.tubeMaterialId);
    }
    get specifications() {
        return this.tubes.filter(t => this.tubeMaterialId === t.tubeMaterialId && t.tubeProfileId === this.tubeProfileId)
            .map(t => t.tubeSpecificationId);
    }
    get tubeId() {
        const t = this.shopConfig.tubes.find(t => t.tubeMaterialId === this.tubeMaterialId && t.tubeProfileId === this.tubeProfileId && t.tubeSpecificationId === this.tubeSpecificationId);
        return t === undefined ? "" : t.identifier;
    }
    get tubeIdValid() {
        return this.tubeId !== "";
    }
    mounted() {
        this.initialize();
    }
    onValueChanged() {
        this.initialize();
    }
    onTubeIdChanged() { this.tubeIdChanged(); }
};
__decorate([
    Prop({ required: true })
], TubeElement.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], TubeElement.prototype, "tubeProfileSelectionDisabled", void 0);
__decorate([
    Prop({ required: true })
], TubeElement.prototype, "value", void 0);
__decorate([
    Inject()
], TubeElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], TubeElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], TubeElement.prototype, "tubeIdChanged", null);
__decorate([
    Watch("value")
], TubeElement.prototype, "onValueChanged", null);
__decorate([
    Watch("tubeId")
], TubeElement.prototype, "onTubeIdChanged", null);
TubeElement = __decorate([
    Component({
        components: {
            TubeMaterialSelection,
            TubeProfileSelection,
            TubeSpecificationSelection,
        },
        name: "TubeElement",
    })
], TubeElement);
export default TubeElement;
